/* ew-ficha.js - 17-sep-2026
   Dos cosas en la seccion «Mas informacion» de la ficha:
   1) Si la foto de esa seccion es la MISMA que una de la galeria, se quita
      (repetir la portada no aporta nada) y la ficha tecnica pasa a una sola
      columna centrada. Los planos de medidas, que NO estan en la galeria, se
      quedan.
   2) En escritorio los datos (medidas, material, caracteristicas, embalaje)
      salen abiertos: quien compra un mueble no deberia tener que abrir cuatro
      desplegables. En movil sigue plegado, con el primero abierto.
   No se toca la pestana de descarga de 3D (data-ew-dl="1").

   05-oct-2026 (ficha opcion B): la foto de «Mas informacion» se queda SIEMPRE a la
   izquierda (orden del usuario: «siempre pon la foto a la izquierda»), aunque repita
   una de la galeria; dedupeMedia() ya no la quita. Y se suman: material por variante,
   envio gratis dentro de la casilla ENTREGA Y ENVIO, corazon de la lista de deseos en
   la linea del precio, pestanas bajadas a «Mas informacion» y barra fija en movil. */
(function () {
  var DESK = 990;

  function base(u) {
    if (!u) return '';
    try {
      var p = new URL(u, location.href).pathname.split('/').pop().split('?')[0];
      return p.replace(/_\d+x\d*(_crop_[a-z]+)?\./, '.').replace(/\.(jpe?g|png|webp|avif)$/i, '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function galleryNames() {
    var out = [];
    var imgs = document.querySelectorAll('.product-grid__item--media-wrapper img, .product__media img, .product__gallery img');
    for (var i = 0; i < imgs.length; i++) {
      var n = base(imgs[i].currentSrc || imgs[i].src);
      if (n) out.push(n);
    }
    return out;
  }

  function dedupeMedia() {
    /* 05-oct-2026: desactivado, la foto se queda siempre. */
    return;
    var sec = document.querySelector('.section-complete-the-set');
    if (!sec || sec.dataset.ewDedupe === '1') return;
    var img = sec.querySelector('.section__media img');
    if (!img) return;
    var n = base(img.currentSrc || img.src);
    if (!n) return;
    if (galleryNames().indexOf(n) === -1) return;
    var col = sec.querySelector('.section-complete-the-set__content');
    if (col) {
      col.style.display = 'none';
      sec.classList.add('ew-ficha--nomedia');
      sec.dataset.ewDedupe = '1';
    }
  }

  /* 19-sep (usuario): «no me gusta asi toda la info suelta, metela en cosas que se
     desplieguen y se lea». O sea: TODO plegado, en ordenador y en movil, y que cada
     apartado se abra al pulsarlo. */
  function specs() {
    var sec = document.querySelector('.section-complete-the-set');
    if (!sec) return;
    var list = sec.querySelectorAll('.section__buttons details.accordion__section');
    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      if (d.dataset.ewDl === '1') continue;
      if (d.dataset.ewTouched === '1') continue;
      d.dataset.ewTouched = '1';
      d.classList.remove('ew-ficha-open');
      d.open = false;
      d.classList.remove('is-active');
      var body = d.querySelector('.accordion__body');
      if (body) body.style.height = '';
    }
  }

  /* Ancla para el enlace «todas las medidas» de la caja de datos. */
  function anchor() {
    if (document.getElementById('ew-ficha')) return;
    var sec = document.querySelector('.section-complete-the-set');
    if (sec && !sec.id) sec.id = 'ew-ficha';
  }

  /* Orden de los datos: primero MEDIDAS, luego MATERIAL, caracteristicas,
     especificaciones y la descripcion al final. Los titulares vienen del
     metafield de cada proveedor, asi que se ordena por palabra clave en los
     idiomas de la tienda. */
  var PRIO = [
    [['medid', 'dimens', 'afmet', 'mal', 'maal'], 1],
    [['material', 'materia', 'materiaal'], 2],
    [['caracter', 'feature', 'kenmerk', 'egenskab'], 3],
    [['especif', 'specif', 'spec'], 4],
    [['embalaje', 'packaging', 'verpakking', 'emballage'], 6],
    [['descrip', 'description', 'beschrij', 'beskriv'], 9]
  ];

  /* Los datos van a su propia reticula: el titular «Mas informacion» y la caja
     de documentacion se quedan fuera, arriba y abajo. */
  function regroup() {
    var box = document.querySelector('.section-complete-the-set .section__buttons');
    if (!box || box.dataset.ewGrouped === '1') return;
    var grid = document.createElement('div');
    grid.className = 'ew-specs';
    var docs = null, desc = null, items = [], kids = [].slice.call(box.children);
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.classList.contains('section__head')) continue;
      if (el.classList.contains('ew-docs')) { docs = el; continue; }
      /* La descripcion larga sale de la reticula: en columna estrecha quedaba
         como un chorro de texto al lado de las tablas. */
      var s = el.querySelector('summary, .drawer__button-text');
      var st = (s ? s.innerText : '').toLowerCase();
      if (!desc && (st.indexOf('descrip') > -1 || st.indexOf('beschrij') > -1 || st.indexOf('beskriv') > -1)) {
        desc = el;
        continue;
      }
      items.push(el);
    }
    if (!items.length && !desc) return;
    if (desc) {
      /* La descripcion va la primera de la lista, tambien plegada. */
      var wrap = document.createElement('div');
      wrap.className = 'ew-desc';
      wrap.appendChild(desc);
      box.appendChild(wrap);
    }
    for (var j = 0; j < items.length; j++) grid.appendChild(items[j]);
    box.appendChild(grid);
    if (docs) box.appendChild(docs);
    box.dataset.ewGrouped = '1';
  }

  /* Se reordena MOVIENDO los bloques, no con `order`: la reticula de datos es
     multicolumna (columns), y ahi `order` no hace nada. */
  function orderSpecs() {
    var box = document.querySelector('.section-complete-the-set .ew-specs');
    if (!box || box.dataset.ewOrdered === '1') return;
    var items = [];
    for (var i = 0; i < box.children.length; i++) {
      var item = box.children[i];
      if (item.classList.contains('section__head') || item.classList.contains('ew-docs')) continue;
      var s = item.querySelector('summary, .drawer__button-text');
      var t = (s ? s.innerText : '').toLowerCase();
      var o = 5;
      for (var j = 0; j < PRIO.length; j++) {
        var keys = PRIO[j][0];
        for (var k = 0; k < keys.length; k++) {
          if (t.indexOf(keys[k]) > -1) { o = PRIO[j][1]; break; }
        }
        if (o !== 5) break;
      }
      items.push([o, i, item]);
    }
    if (!items.length) return;
    items.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    for (var n = 0; n < items.length; n++) box.appendChild(items[n][2]);
    box.dataset.ewOrdered = '1';
  }

  /* El selector de variantes se pinta siempre, tambien sin variantes: dejaba
     dos rayas sueltas debajo del precio. */
  function emptyPicker() {
    var p = document.querySelector('.product__content > .product__variant-picker');
    if (!p) return;
    var ctrl = p.querySelectorAll('input, select, button, label, .product-groups__item');
    var vis = 0;
    for (var i = 0; i < ctrl.length; i++) {
      if (ctrl[i].offsetHeight > 2) vis++;
    }
    if (vis === 0) p.classList.add('ew-empty'); else p.classList.remove('ew-empty');
  }

  /* En los datos del proveedor, una linea sin «:» se pinta como titulillo de
     grupo (terracota, mayuscula). Cuando la linea es una frase entera («El grosor
     de la tapa ... es de 0,3 cm.») eso parece un titulo y no lo es: se pasa a
     nota normal. Los titulillos de verdad (OTRAS MEDIDAS, EMBALAJE) son cortos. */
  function notes() {
    var els = document.querySelectorAll('.section-complete-the-set .ewh-datos__grupo');
    for (var i = 0; i < els.length; i++) {
      /* textContent, no innerText: dentro de un acordeon cerrado innerText es ''. */
      var t = (els[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 34) els[i].classList.add('ew-nota');
    }
  }

/* 19-sep-2026: caja de datos (ew-key-facts) — si la medida depende de la talla, se
     actualiza con la variante elegida (URL ?variant= o el input name="id" del formulario). */
  function kfSize() {
    var el = document.querySelector('[data-ew-kf-size][data-ew-kf-map]');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.getAttribute('data-ew-kf-map')); } catch (e) { return; }
    var id = null;
    try { id = new URLSearchParams(location.search).get('variant'); } catch (e) { id = null; }
    if (!id || !map[id]) {
      var inp = document.querySelector('.product__content form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
      if (inp && inp.value) id = inp.value;
    }
    if (id && map[id] && el.textContent !== map[id]) el.textContent = map[id];
  }
  function currentVariantId() {
    var id = null;
    try { id = new URLSearchParams(location.search).get('variant'); } catch (e) { id = null; }
    if (!id) {
      var inp = document.querySelector('.product__content form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
      if (inp && inp.value) id = inp.value;
    }
    return id;
  }
  /* 19-sep-2026: disponibilidad de la variante elegida (ew-key-facts, data-ew-kf-amap). */
  function kfAvail() {
    var el = document.querySelector('[data-ew-kf-avail][data-ew-kf-amap]');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.getAttribute('data-ew-kf-amap')); } catch (e) { return; }
    var id = currentVariantId();
    if (!id || !(id in map)) return;
    var v = map[id];
    var inStock = v === 1 || (v === -1 && el.getAttribute('data-ew-kf-total') === '1');
    var val = el.querySelector('.ew-keyfacts__val'), note = el.querySelector('.ew-keyfacts__note');
    var t1 = el.getAttribute(inStock ? 'data-ew-kf-in' : 'data-ew-kf-out');
    var t2 = el.getAttribute(inStock ? 'data-ew-kf-in-note' : 'data-ew-kf-out-note');
    if (val && val.textContent !== t1) val.textContent = t1;
    if (note && note.textContent !== t2) note.textContent = t2;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.product__variant-picker, variant-selects, variant-radios, .product-form, product-info')) return;
    setTimeout(function () { kfSize(); kfAvail(); kfMat(); }, 60);
    setTimeout(function () { kfSize(); kfAvail(); kfMat(); }, 400);
    /* El tema puede repintar la columna al cambiar de variante: se recoloca todo. */
    setTimeout(run, 900);
  });
  window.addEventListener('popstate', function () { kfSize(); kfAvail(); kfMat(); });


  /* ================= 05-oct-2026 · FICHA OPCIÓN B =================
     Lo que no se puede hacer en Liquid sin tocar las 24 plantillas. */

  /* Material de la variante elegida (ew-key-facts, data-ew-kf-mmap). */
  function kfMat() {
    var el = document.querySelector('[data-ew-kf-mat][data-ew-kf-mmap]');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.getAttribute('data-ew-kf-mmap')); } catch (e) { return; }
    var id = currentVariantId();
    if (id && map[id] && el.textContent !== map[id]) el.textContent = map[id];
  }

  /* «Envío gratis» en la casilla ENTREGA, SOLO si el producto lo tiene (el template trae
     la línea «¡Envíos gratis!…»). 05-oct, 2.ª vuelta (usuario: «es mucha información»):
     ya no se copia la frase entera con montaje y elevación, solo la etiqueta corta, y las
     líneas del template se ocultan para no decirlo dos veces. */
  var SHIP_RE = /env[ií]os? gratis|env[ií]o gratuito|free shipping|free delivery|gratis verzending|gratis bezorg|livraison gratuite|livraison offerte|portes gr[aá]tis|entrega gratuita|fri fragt/i;
  var SHIP_LABEL = { es: 'Envío gratis', en: 'Free shipping', nl: 'Gratis verzending', fr: 'Livraison offerte', pt: 'Envio grátis', da: 'Gratis fragt' };
  function shipText() {
    var slot = document.querySelector('[data-ew-kf-ship]');
    if (!slot || slot.dataset.ewDone === '1') return;
    var nodes = document.querySelectorAll('.product__content .product__text.product__block');
    var found = 0;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList.contains('product__inventory-notice')) continue;
      if (n.closest('.product__tab-content') || n.closest('.ew-gtk') || n.closest('.product__tabs-wrapper')) continue;
      var s = (n.textContent || '').replace(/\s+/g, ' ').trim();
      if (s.length > 0 && s.length < 160 && SHIP_RE.test(s)) { n.classList.add('ew-ship-dup'); found++; }
    }
    if (found) {
      var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
      var tag = document.createElement('span');
      tag.className = 'ew-kf2__ship';
      tag.textContent = SHIP_LABEL[lang] || SHIP_LABEL.en;
      slot.appendChild(tag);
    }
    slot.dataset.ewDone = '1';
  }

  /* Las líneas sueltas del template (montaje, hecho a mano…) iban una debajo de otra,
     pegadas a los botones. Se agrupan en una franja discreta (05-oct, 2.ª vuelta). */
  function notesGroup() {
    var pc = document.querySelector('.product__content');
    if (!pc) return;
    var old = pc.querySelector('.ew-notes');
    if (old && old.parentNode === pc) return;
    var list = [], kids = pc.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (!k.classList.contains('product__text') || k.classList.contains('ew-ship-dup')) continue;
      /* El aviso de plazo del tema repite la fecha de la casilla ENTREGA: fuera. */
      if (k.classList.contains('product__inventory-notice') || k.classList.contains('product__preorder-warning')) continue;
      if ((k.textContent || '').replace(/\s+/g, '').length === 0) continue;
      list.push(k);
    }
    if (!list.length) return;
    var w = document.createElement('div');
    w.className = 'ew-notes';
    for (var j = 0; j < list.length; j++) w.appendChild(list[j]);
    pc.appendChild(w);
  }

  /* Casilla ENTREGA Y ENVÍO vacía (sin plazo, sin disponibilidad y sin envío): fuera.
     Y si la cuadrícula se queda sin casillas, fuera también. */
  function kfEmpty() {
    var grid = document.querySelector('.ew-kf2');
    if (!grid) return;
    var d = grid.querySelector('.ew-kf2__deliv');
    if (d) {
      var dv = d.querySelector('.ew-deliv');
      var hasDeliv = dv && !dv.hidden && (dv.textContent || '').replace(/\s+/g, '').length > 0;
      var has = d.querySelector('.ew-keyfacts__val') || hasDeliv || d.querySelector('.ew-kf2__ship') || d.querySelector('.ew-deliv-box__stock');
      d.classList.toggle('is-empty', !has);
    }
    grid.classList.toggle('is-empty', grid.querySelectorAll('.ew-kf2__cell:not(.is-empty)').length === 0);
  }

  /* Lista de deseos: solo el corazón, en la línea del precio (el texto de la app
     salía en inglés, «Add to Wishlist»). */
  function wishlist() {
    var price = document.querySelector('.product__content > .product__price');
    if (!price || price.querySelector('.ew-wish')) return;
    var blocks = document.querySelectorAll('.product__content > .product__app-block');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('.st-wishlist-button')) {
        blocks[i].classList.add('ew-wish');
        price.appendChild(blocks[i]);
        return;
      }
    }
  }

  /* Pestañas «Sobre envíos · Personalizar · Interiorista» y «A tener en cuenta»:
     bajan a «Más información», debajo de los datos. La columna de compra se queda
     con lo que decide la compra. */
  function moveTabs() {
    var box = document.querySelector('.section-complete-the-set .section__buttons');
    if (!box || box.dataset.ewTabs === '1') return;
    var tabs = document.querySelector('.product__content > .product__tabs-wrapper');
    var gtk = document.querySelector('.product__content > .ew-gtk');
    if (!tabs && !gtk) return;
    var wrap = document.createElement('div');
    wrap.className = 'ew-more-extra';
    if (tabs) wrap.appendChild(tabs);
    if (gtk) wrap.appendChild(gtk);
    var docs = box.querySelector('.ew-docs');
    if (docs) box.insertBefore(wrap, docs); else box.appendChild(wrap);
    box.dataset.ewTabs = '1';
  }

  /* Barra fija en móvil: aparece siempre que el botón principal NO esté a la vista
     (todavía más abajo o ya pasado). Repite el precio (o nada, si el precio está
     oculto) y pulsa el mismo botón de la ficha: añadir a la cesta o consultar precio.
     Sin requestAnimationFrame: con la pestaña en segundo plano no corre (mismo
     problema que tuvo el botón CON/SIN IVA el 18-sep). */
  function sbTarget() {
    var b = document.querySelector('.product__content > .product__buy-buttons');
    if (!b) return null;
    return b.querySelector('button[name="add"]') || b.querySelector('.ew-gate__btn--primary');
  }
  function stickyBar() {
    if (document.querySelector('.ew-sbar') || !sbTarget()) return;
    var bar = document.createElement('div');
    bar.className = 'ew-sbar';
    var info = document.createElement('div');
    info.className = 'ew-sbar__info';
    var name = document.createElement('span');
    name.className = 'ew-sbar__name';
    var price = document.createElement('span');
    price.className = 'ew-sbar__price';
    info.appendChild(name);
    info.appendChild(price);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ew-sbar__btn';
    btn.addEventListener('click', function () { var t = sbTarget(); if (t) t.click(); });
    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    function sync() {
      var t = sbTarget();
      var tm = document.querySelector('.product__title .ew-title__main');
      name.textContent = tm ? tm.textContent.trim() : '';
      var p = document.querySelector('.product__content > .product__price .price');
      var txt = '';
      if (p && !p.classList.contains('price--gated')) {
        var it = p.querySelector('.price-item--sale') || p.querySelector('.price-item--last') || p.querySelector('.price-item--regular') || p;
        txt = (it.textContent || '').replace(/\s+/g, ' ').trim();
      }
      price.textContent = txt;
      price.hidden = !txt;
      btn.textContent = t ? (t.innerText || t.textContent || '').replace(/\s+/g, ' ').trim() : '';
      bar.classList.toggle('is-disabled', !t || !!t.disabled);
    }
    function check() {
      var b = document.querySelector('.product__content > .product__buy-buttons');
      var on = false;
      if (b && b.offsetHeight) {
        var r = b.getBoundingClientRect();
        on = r.bottom < 0 || r.top > (window.innerHeight || document.documentElement.clientHeight);
      }
      if (on && !bar.classList.contains('is-on')) sync();
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('ew-sbar-on', on);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    /* Al cargar, la galería aún no mide lo que medirá: se vuelve a mirar. */
    window.addEventListener('load', check);
    setTimeout(check, 1200);
    setTimeout(check, 3000);
    sync();
    check();
  }

  function run() {
    kfSize();
    kfAvail();
    kfMat();
    shipText();
    wishlist();
    anchor();
    notes();
    dedupeMedia();
    regroup();
    orderSpecs();
    emptyPicker();
    specs();
    moveTabs();
    notesGroup();
    kfEmpty();
    stickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  var t = null;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(specs, 200);
  });
  setTimeout(run, 800);
})();

/* 12-oct-2026: «Leer mas» del extracto de la descripcion (snippets/ew-key-facts.liquid): abre la descripcion
   completa de «Mas informacion» y baja hasta ella. Va aqui (y no en ew-acabados.js) porque este fichero
   carga en TODAS las fichas, tengan o no cartas de acabados. */
(function () {
  function wire() {
    var links = document.querySelectorAll('[data-ew-more]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].dataset.ewWired) continue;
      links[i].dataset.ewWired = '1';
      links[i].addEventListener('click', function (e) {
        var sec = document.querySelector('.section-complete-the-set');
        if (!sec) return;
        e.preventDefault();
        var s = sec.querySelector('.ew-desc summary') || sec.querySelector('details.accordion__section summary');
        if (s && s.parentNode && !s.parentNode.open) s.click();
        var y = sec.getBoundingClientRect().top + window.pageYOffset - 90;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
  window.addEventListener('load', wire);
})();
